import { exportConstants } from '../../../../../constants'

const initialState = {
	isExporting: false,
	downloadData: null
}

function pointsBreakageReducer(
	state = initialState,
	{ type, payload: downloadData }
) {
	switch (type) {
		case exportConstants.EXPORT_DATA:
			return {
				...state,
				isExporting: true
			}

		case exportConstants.DOWNLOAD_DATA:
			return {
				...state,
				isExporting: false,
				downloadData
			}

		default:
			return state
	}
}

export { pointsBreakageReducer as Reducer }
